import { ReactNode, useId } from 'react';
import { twMerge } from 'tailwind-merge';

type SizeVariant = 'xs' | 'sm' | 'md' | 'lg';
const variantStyles = {
  xs: 'body-sm',
  sm: 'body-md',
  md: 'body-lg',
  lg: 'subheading-md text-on-surface',
} satisfies Record<SizeVariant, string>;

export function DescriptionListItem({
  label,
  value,
  variant = 'md',
}: {
  label: string;
  value: ReactNode;
  variant?: SizeVariant;
}) {
  const id = useId();

  const styles = variantStyles[variant];

  return (
    <>
      <dt id={id} className={styles}>
        {label}
      </dt>
      <dd aria-labelledby={id} className={twMerge(styles, 'text-right')}>
        {value}
      </dd>
    </>
  );
}

export default function DescriptionList({
  className,
  children,
  divide,
}: {
  className?: string;
  divide?: boolean;
  children?: ReactNode;
}) {
  return (
    <dl
      className={twMerge(
        'grid grid-cols-2 *:py-2 *:first:pt-0 *:last:pb-0 *:nth-2:pt-0 *:nth-last-2:pb-0',
        divide && 'gap-y-px bg-outline-variant *:bg-surface-container-lowest',
        className,
      )}
      data-component="corso-description-list"
    >
      {children}
    </dl>
  );
}
